export const DEFAULT_LOCALE = "en-US";

export const IS_BROWSER = typeof window !== "undefined";
